import { useState } from "react";
import { Card, CardBody, Col, Toast, ToastBody } from "reactstrap";
import { Btn, Image } from "../../../../AbstractElements";
import { DefaultToastTitle } from "../../../../Constants/Constants";
import { ColorsSchemeSubTitle } from "../../../../Data/BonusUi/Toasts";
import { dynamicImage } from "../../../../Utils";
import CommonCardHeader from "../../../CommonComponents/CommonCardHeader/CommonCardHeader";

const DefaultToast = () => {
  const [open, setOpen] = useState(true);
  return (
    <Col md="6">
      <Card className="height-equal">
        <CommonCardHeader title={DefaultToastTitle} span={ColorsSchemeSubTitle} />
        <CardBody className="toast-rtl">
          <Toast className="default-show-toast" isOpen={open}>
            <div className="toast-img toast-header">
              <Image className="rounded me-2" src={dynamicImage(`profile.png`)} alt="profile" />
              <strong className="me-auto">{"Moscow Theme"}</strong>
              <small className="d-sm-block d-none">{"10 min ago"}</small>
              <Btn close className="p-0" onClick={() => setOpen(false)}></Btn>
            </div>
            <ToastBody className="toast-dark">
              <strong className="txt-success">{"Well done!"}</strong> {"You successfully read this important message."}
            </ToastBody>
          </Toast>
        </CardBody>
      </Card>
    </Col>
  );
};
export default DefaultToast;
